import axios from '@axios';

const base = '/api/v1/announcements';

export default {
  checkPreCallAnnouncements(prisonId) {
    return axios.get(`${base}/prison/pre-call-va/${prisonId}`);
  },
  getAnnouncementMotdAd(prisonId) {
    return axios.get(`${base}/prison/motd-ad/${prisonId}`);
  },
}
